// import React from "react";

// const values = [
//   {
//     title: "Services",
//     desc: "Our focus is on providing reliable service that meets and exceeds customer expectations.",
//     icon: "⚙️",
//   },
//   {
//     title: "Transparent",
//     desc: "We value openness and clarity in everything we do.",
//     icon: "🔍",
//   },
//   {
//     title: "Innovation",
//     desc: "We encourage new perspectives that drive meaningful change.",
//     icon: "💡",
//   },
//   {
//     title: "Fun",
//     desc: "We balance dedication with a positive, enjoyable work culture.",
//     icon: "🎲",
//   },
//   {
//     title: "Growth",
//     desc: "Driven by vision and growth, we create new possibilities.",
//     icon: "📈",
//   },
// ];

// const CareersValuesAndForm = () => {
//   return (
//     <section className="w-full bg-white">
//       {/* ===== Values Section ===== */}
//       <div className="bg-[#1f4e6e] py-20">
//         <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//           {/* Cards */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//             {values.slice(0, 3).map((item, idx) => (
//               <div
//                 key={idx}
//                 className="bg-white rounded-xl shadow-lg px-6 py-8 text-center"
//               >
//                 <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border text-xl">
//                   {item.icon}
//                 </div>
//                 <h4 className="font-semibold">{item.title}</h4>
//                 <p className="mt-2 text-sm text-gray-600">{item.desc}</p>
//               </div>
//             ))}
//           </div>

//           {/* Bottom centered cards */}
//           <div className="mt-10 flex flex-wrap justify-center gap-8">
//             {values.slice(3).map((item, idx) => (
//               <div
//                 key={idx}
//                 className="w-full max-w-sm bg-white rounded-xl shadow-lg px-6 py-8 text-center"
//               >
//                 <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border text-xl">
//                   {item.icon}
//                 </div>
//                 <h4 className="font-semibold">{item.title}</h4>
//                 <p className="mt-2 text-sm text-gray-600">{item.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* ===== Contact Form ===== */}
//       <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-16">
//         <h3 className="font-semibold text-lg mb-8">
//           Contact us to sign up for our Careers mailing list and stay updated on
//           future career opportunities.
//         </h3>

//         <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           <input
//             type="text"
//             placeholder="Enter Your Full Name"
//             className="border p-3 rounded"
//           />
//           <input
//             type="email"
//             placeholder="Enter Your Email"
//             className="border p-3 rounded"
//           />
//           <input
//             type="text"
//             placeholder="Enter Your Mobile Number"
//             className="border p-3 rounded"
//           />
//           <input
//             type="text"
//             placeholder="Subject"
//             className="border p-3 rounded"
//           />

//           <textarea
//             placeholder="Message"
//             rows="4"
//             className="border p-3 rounded md:col-span-2"
//           />

//           <div className="md:col-span-2">
//             <label className="block text-sm mb-2">Upload Your CV</label>
//             <input type="file" />
//           </div>

//           <div className="md:col-span-2">
//             <button
//               type="submit"
//               className="bg-[#0b4864] text-white px-6 py-3 rounded-md hover:bg-[#093b52]"
//             >
//               SEND MESSAGE
//             </button>
//           </div>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default CareersValuesAndForm;

import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const values = [
  {
    title: "Services",
    desc: "Our focus is on providing reliable service that meets and exceeds customer expectations.",
    icon: "⚙️",
  },
  {
    title: "Transparent",
    desc: "We value openness and clarity in everything we do.",
    icon: "🔍",
  },
  {
    title: "Innovation",
    desc: "We encourage new perspectives that drive meaningful change.",
    icon: "💡",
  },
  {
    title: "Fun",
    desc: "We balance dedication with a positive, enjoyable work culture.",
    icon: "🎲",
  },
  {
    title: "Growth",
    desc: "Driven by vision and growth, we create new possibilities.",
    icon: "📈",
  },
];

const CareersValuesAndForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          service: "Career Application",
          name: formData.name,
          email: formData.email,
          phone: formData.phone || "N/A",
          company: "N/A",
          message: `
Subject: ${formData.subject}

${formData.message}
          `,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      );

      setSuccess(true);
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("Email Error:", error);
      alert("Failed to send message. Please try again.");
    }

    setIsSubmitting(false);
  };

  return (
    <section className="w-full bg-white">
      {/* ===== Values Section ===== */}
      <div className="bg-[#1f4e6e] py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {values.slice(0, 3).map((item, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl shadow-lg px-6 py-8 text-center"
              >
                <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border text-xl">
                  {item.icon}
                </div>
                <h4 className="font-semibold">{item.title}</h4>
                <p className="mt-2 text-sm text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap justify-center gap-8">
            {values.slice(3).map((item, idx) => (
              <div
                key={idx}
                className="w-full max-w-sm bg-white rounded-xl shadow-lg px-6 py-8 text-center"
              >
                <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border text-xl">
                  {item.icon}
                </div>
                <h4 className="font-semibold">{item.title}</h4>
                <p className="mt-2 text-sm text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ===== Contact Form ===== */}
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-16">
        <h3 className="font-semibold text-lg mb-8">
          Contact us to sign up for our Careers mailing list and stay updated on
          future career opportunities.
        </h3>

        {success && (
          <p className="text-green-600 mb-4">
            ✅ Application submitted successfully!
          </p>
        )}

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter Your Full Name"
            required
            className="border p-3 rounded"
          />

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter Your Email"
            required
            className="border p-3 rounded"
          />

          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter Your Mobile Number"
            className="border p-3 rounded"
          />

          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Subject"
            className="border p-3 rounded"
          />

          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Message"
            rows="4"
            required
            className="border p-3 rounded md:col-span-2"
          />

          <div className="md:col-span-2">
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-[#0b4864] text-white px-6 py-3 rounded-md hover:bg-[#093b52] disabled:opacity-60"
            >
              {isSubmitting ? "Sending..." : "SEND MESSAGE"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default CareersValuesAndForm;
